import {storage, StorageKeys} from '../storage/index';

export async function getCabinetAuthToken(): Promise<string | null> {
  const token = await storage.getItem<string>(StorageKeys.token);
  if (token) {
    return token;
  }

  return storage.getItem<string>(StorageKeys.activationToken);
}

export async function getCabinetAuthHeaders(): Promise<Record<string, string>> {
  const token = await getCabinetAuthToken();

  return token ? {Authorization: `Bearer ${token}`} : {};
}
